import Crud from '../views/TipoUnidade/Crud'
import Entity from '../views/TipoUnidade/Add'
import View from '../views/TipoUnidade/View'

let routes = {
    path: '/tipo_unidades',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_unidades/add',
            name: 'NewTipoUnidade',
            component: Entity,
            meta: {
                pageTitle: 'Criação de Tipos de Unidades',
                breadcrumb: [
                    {
                        text: 'Tipos de Unidades',
                        active: false,
                        to: '/tipo_unidades',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_unidades/edit/:id?',
            name: 'EditTipoUnidade',
            component: Entity,
            meta: {
                pageTitle: 'Edição de Tipos de Unidades',
                breadcrumb: [
                    {
                        text: 'Tipos de Unidades',
                        active: false,
                        to: '/tipo_unidades',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_unidades/view/:id?',
            name: 'ViewTipoUnidade',
            component: View,
            meta: {
                pageTitle: 'Visualizar Tipos de Unidades',
                breadcrumb: [
                    {
                        text: 'Tipos de Unidades',
                        active: false,
                        to: '/tipo_unidades',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_unidades',
            name: 'list-tipo_unidades',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Unidades',
                breadcrumb: [
                    {
                        text: 'Tipos de Unidades',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
